// Same-origin in production (Express serves this build); override for local dev
// via website/.env.development → REACT_APP_API_URL=http://localhost:3000
const BASE_URL = process.env.REACT_APP_API_URL || '';
const opts = { credentials: 'include' };
const getAlive = () => fetch(`${BASE_URL}/api/top`, opts).then(res => res.json())
const getProfile = (id) => fetch(`${BASE_URL}/api/profile/${id}`, opts).then(res => res.json())
const getServers = () => fetch(`${BASE_URL}/api/getservers`, opts).then(res => res.json())
const getPassport = () => fetch(`${BASE_URL}/api/getpassport`, opts).then(res => res.json())
const getUsernameAndUrl = (id) => fetch(`${BASE_URL}/api/userinfo/${id}`, opts).then(res => res.json())
const getTop = () => fetch(`${BASE_URL}/api/top`, opts).then(res => res.json())
const customizeProfileData = (userid, description, profile, bg, color, birthdate, font, badge1, badge2, badge3, badge4) =>
  fetch(`${BASE_URL}/api/updateprofile/${userid}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      Description: description,
      profile,
      background: bg,
      color,
      birthday: birthdate,
      font,
      badge1,
      badge2,
      badge3,
      badge4,
    }),
  }).then(res => res.json())
const buyItem = (category, tag) =>
  fetch(`${BASE_URL}/api/buy`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ category, tag }),
  }).then(res => res.json())
module.exports = {
    getAlive,
    getProfile,
    getServers,
    getPassport,
    getUsernameAndUrl,
    getTop,
    customizeProfileData,
    buyItem

}
